import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { DepartmentUser } from "../../../model/department-user";
import { DepartmentUserService } from "../../../services/department-user.service";
import { UsersService } from "../../../services/users.service";
import { NavigationHelper } from "../../../services/navigation.helper";
import { AuthService } from "../../../auth.service";
import { Messages } from "../../../model/messages";
import { Navigation } from "../../../model/navigation";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  selector: "department-user",
  templateUrl: "./department-user.component.html",
  styleUrls: ["./department-user.component.css"],
})
export class DepartmentUserComponent implements OnInit {
  messages: BehaviorSubject<Messages> = new BehaviorSubject(Messages.EMPTY);
  departmentUsers: BehaviorSubject<DepartmentUser[]> = new BehaviorSubject<
    DepartmentUser[]
  >([]);
  selectedDepartmentUser: DepartmentUser | null = null;
  showCreateForm: boolean = false;
  editMode: boolean = false;
  departmentUserForm: FormGroup;
  currentId: number | null;
  @Input() currentDepartmentId: Observable<number>;
  supervisor: boolean = false;
  @Output() departmentUserSelected = new EventEmitter<number>();

  constructor(
    private departmentUserService: DepartmentUserService,
    private usersService: UsersService,
    private nav: NavigationHelper,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentDepartmentId.subscribe((id) => {
      this.currentId = id;
      if (id > 0) {
        this.loadDepartmentUsers(id);
      }
    });

    this.showCreateForm = false;
    this.nav.fragmentId.subscribe((id) => {
      this.adaptToNavigation();
    });
    this.adaptToNavigation();
    this.supervisor = this.authService.isSupervisor();
  }

  adaptToNavigation() {
    const current = this.nav.current;
    const fragmentId = Number(current.fragmentId);
    if (
      this.nav.currentFragmentTopic === "department-user" &&
      fragmentId === Navigation.NEW &&
      "fragmentedit" === current.action
    ) {
      const newDepartmentUser = new DepartmentUser(0, 0, -9);

      this.departmentUserService.select(newDepartmentUser);
    }
    if ("fragmentedit" === current.action) {
      this.editMode = true;
      this.showCreateForm = true;
    } else {
      this.editMode = false;
      this.showCreateForm = false;
    }
  }
  loadDepartmentUsers(departmentId: number): void {
    const token = this.authService.token;
    this.departmentUserService.getByDepartment(token, departmentId).subscribe(
      (departmentUsers) => {
        this.departmentUsers.next(
          this.departmentUserService.currentDepartmentUsers.value
        );
      },
      (error) => {
        this.messages.next(
          Messages.from({
            departmentUser: ["department-user.load.failed"],
          })
        );
      }
    );
  }

  createDepartmentUser(): void {
    this.showCreateForm = true;
    this.editMode = true;

    this.currentDepartmentId.subscribe((departmentId) => {
      const url =
        "departments/" +
        departmentId +
        "/fragmentedit/department-user/" +
        Navigation.NEW;
      this.router.navigate([url]);
    });
  }

  removeDepartmentUser(departmentUser: DepartmentUser): void {
    const token = this.authService.token;
    if (
      departmentUser &&
      departmentUser.departmentId &&
      departmentUser.userId
    ) {
      this.departmentUserService
        .deleteDepartmentUser(token, departmentUser.id)
        .subscribe(
          (response) => {
            this.messages.next(response);

            if (this.currentId) {
              this.loadDepartmentUsers(this.currentId);
            }
          },
          (error) => {
            this.messages.next(
              Messages.from({
                departmentUser: ["department-user.delete.failed"],
              })
            );
          }
        );
    }
  }

  onFormClosed(): void {
    this.showCreateForm = false;
    this.selectedDepartmentUser = null;
  }

  userLabel(departmentUser: DepartmentUser): string {
    const label = this.usersService.labelForId(Number(departmentUser.userId));
    return label;
  }
}
